import { useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CringeShell from './CringeShell';

// The intro clip is 46 MB: served from S3 next to the other game assets (<REACT_APP_S3_PATH>Cringe_intro.mp4,
// REACT_APP_INTRO_VIDEO_URL overrides it). The copy bundled with the app is the fallback.
const LOCAL_VIDEO = '/cringe/img/Cringe_intro.mp4';
const S3_BASE = process.env.REACT_APP_S3_PATH;
const INTRO_VIDEO =
  process.env.REACT_APP_INTRO_VIDEO_URL || (S3_BASE ? `${S3_BASE.replace(/\/?$/, '/')}Cringe_intro.mp4` : LOCAL_VIDEO);

// story.php: autoplay intro (with sound); Next (or the end of the clip) goes to stage 1.
export default function CringeStory() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const videoRef = useRef(null);
  const [src, setSrc] = useState(INTRO_VIDEO);
  const next = () => navigate({ pathname: '/stage1', search });

  return (
    <CringeShell bgColor="#000" className="cr-story">
      <video
        ref={videoRef}
        className="cr-story-video"
        src={src}
        autoPlay
        playsInline
        preload="metadata"
        onError={() => src !== LOCAL_VIDEO && setSrc(LOCAL_VIDEO)}
        onEnded={next}
      />
      <button type="button" className="cr-img-btn cr-story-next" onClick={next}>
        <img src="/cringe/img/next.png" alt="Next" />
      </button>
    </CringeShell>
  );
}
